import React from 'react'
import { InvisibleRadioButton, InvisibleRadioButtonProps } from 'components/fields/InvisibleRadioButton'

const withRadioGroup = (groupName: string) => function InvisibleRadioButtonWithGroupName (props: InvisibleRadioButtonProps) {
  return <InvisibleRadioButton {...props} groupName={groupName} />
}

export default withRadioGroup
